/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface ServingsByKindOfPerson {
  adults: number;
  children: number;
}

export const aggregateServings = (
  servingsByKindOfPerson: ServingsByKindOfPerson,
) => servingsByKindOfPerson.adults + servingsByKindOfPerson.children * 0.5;

export interface EndUserCollectionsState {
  scaleMealsTo: ServingsByKindOfPerson;
}

const initialState: EndUserCollectionsState = {
  scaleMealsTo: { adults: 2, children: 0 },
};

export const endUserCollectionsSlice = createSlice({
  name: 'endUserCollections',
  initialState,
  reducers: {
    persistScaleMealsToServingsByKindOfPerson: (
      state,
      action: PayloadAction<ServingsByKindOfPerson>,
    ) => {
      state.scaleMealsTo = action.payload;
    },
  },
});

export const { persistScaleMealsToServingsByKindOfPerson } = endUserCollectionsSlice.actions;

export default endUserCollectionsSlice.reducer;
